import { API, GraphQLResult } from '@aws-amplify/api';
import type { GraphQLOptions } from '@aws-amplify/api-graphql';
import { TypedDocumentString } from '../../graphql/graphql';

export default function execute<TResult, TVariables>({
  query,
  variables,
  withApiKey,
}: {
  query: TypedDocumentString<TResult, TVariables>;
  variables?: TVariables extends Record<string, never> ? undefined : TVariables;
  withApiKey?: boolean;
}) {
  const options: GraphQLOptions = {
    query: query.toString(),
    variables: variables as Record<string, unknown>,
  };

  if (withApiKey) {
    options.authMode = 'API_KEY';
  }

  return API.graphql(options) as Promise<GraphQLResult<TResult>>;
}

export const logError = (error: Error) => {
  // eslint-disable-next-line no-console
  console.error(error);
};

export const tryGetFirstError = (error: unknown): Error => {
  let typedError: Error;

  if (
    error &&
    typeof error === 'object' &&
    'errors' in error &&
    Array.isArray(error.errors)
  ) {
    typedError = error.errors[0] as Error;
  } else {
    typedError = error as Error;
  }

  return typedError;
};
